import { onMounted, watch } from 'vue';
import { useUserStore } from '@/helpers/composables/useStores';

/**
 * Composable to update Sentry tags for global user context
 *
 * Currently tracks:
 * - auth_status: User authentication status (logged_in/logged_out)
 *
 * Future additions could include:
 * - experiment_tags: Experiments active variants
 * - user_role: User role (admin, editor, pro, etc.)
 *
 */
export function useSentryTags() {
	const { isLoggedIn } = useUserStore();

	function updateAuthStatusTag() {
		const authStatus = isLoggedIn.value ? 'logged_in' : 'logged_out';
		import('@/helpers/sentry-helper').then(({ updateSentryTags }) => {
			updateSentryTags({ auth_status: authStatus });
		});
	}

	onMounted(() => {
		watch(
			isLoggedIn,
			() => {
				updateAuthStatusTag();
			},
			{ immediate: true }
		);
	});
}
